import React from "react"
import {graphql} from "gatsby"
// import Header from "../components/header"
import Corps from "../components/corps"
import PlaceElement from "../components/placeElement"
import Byline from "../components/byline"
import Social from "../components/social"
import articleStyles from "./articles.module.scss"
import Seo from "../components/seo"

const articles = ({data}) => {
  const result = data.wasp.result
  const mainElement = data.mainElement
  console.log('result: '+ JSON.stringify(result))

  return (
    <div>
      <Seo
        title={result.headline}
        lead={result.lead}
        canonical={result.canonicalUrl}
              />
      <div className={articleStyles.pageStructure}>
        <div className={articleStyles.articleContainer}>

          <div className={articleStyles.enteteArticle}>
            <h1>{result.headline}</h1>
            <div>
              {(mainElement.type !== 'none') ? <PlaceElement object={mainElement} sizes="(max-width: 850px) 90vw, 800px"/> : ''}
            </div>
          </div>

          <div className={articleStyles.corpsArticle}>
            <div className={articleStyles.social}>
              <Social/>
            </div>
            <div className={articleStyles.contenu}>
              <div className={articleStyles.byline}>
                <Byline author={result.authors} datelineCreationDate={result.datelineCreationDate} datelineUpdateDate={result.datelineUpdateDate} authoring={result.authoringInfo}/>
              </div>
              <div className={articleStyles.corps}>
                <Corps content={result.contents[0].content} secondaryObjects={result.secondaryObjects}/>
              </div>
            </div>
          </div>

        </div>
        {/*<div className={articleStyles.rightRail}>*/}
        {/*  rail*/}
        {/*</div>*/}
      </div>
    </div>
  )
}

export default articles


export const query = graphql`
query($slug: String!){
  mainElement(relativeUrl: {eq: $slug}){
    relativeUrl
        type
        title
        brightcoveId
        photos {
          description
          creditLine
          orientation
          photoFormatsS3 {
            photoFormatType
            fileName
            x
            y
            w
            h
          }
        }
        creditLine
        description
        photoFormatsS3 {
          fileName
          h
          w
          x
          y
          photoFormatType
        }
  }
  wasp ( result: {relativeUrl: {eq: $slug}}){
    result {
      datelineCreationDate
      datelineUpdateDate
      authoringInfo
      canonicalUrl
      authors {
        firstName
        lastName
        mainPhoto {
          photoFormatsS3 {
            photoFormatType
            fileName
            x
            y
            w
            h
          }
        }
      }
      lead
      relativeUrl
          secondaryObjects {
            type
            referenceNo
            description
            creditLine
            location
            copyrightNotice
            authoringInfo
            orientation
            urlSourceFromExternal
            title
            source
            html
            brightcoveId
            photoFormatsS3 {
              fileName
              h
              photoFormatType
              w
              x
              y
            }
            photos{
              type
              photoFormatsS3{
                fileName
                h
                photoFormatType
                w
                x
                y
              }
            }
          }
          contents {
            content
            platformType
          }
          headline
          mainPhoto {
            photoFormatsS3 {
              photoFormatType
              fileName
              x
              y
              w
              h
            }
          }
    }
  }
}

`

